import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formartDate } from '@/utils/index';
export default {
  props: {
    title: {
      type: String,
      default: null
    },
    formData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    btnType: {
      type: String,
      default: null
    }
  },
  // watch: {
  //   formData: {
  //     handler(newVal, oldVal) {
  //        console.log(newVal,oldVal,"sdadasdasd")
  //        this.$emit('changesearch',newVal)
  //     },
  //     deep: true,
  //   },
  // },
  data: function data() {
    return {
      formInline: {
        user: '',
        region: '',
        date: null
      },
      defaulttime: ['00:00:00', '23:59:59']
    };
  },
  methods: {
    changeSelect: function changeSelect(item) {
      this.$emit('changeSelect', item);
    },
    changeDate: function changeDate(date) {
      if (date) {
        this.formData.forEach(function (item) {
          if (item.type === 'date1') {
            item.value = formartDate(date, 'yyyy-MM-dd hh:mm:ss');
          }
          if (item.type === 'date2') {
            item.value = date.map(function (v) {
              return formartDate(v, 'yyyy-MM-dd hh:mm:ss');
            });
          }
        });
      }
    },
    handleChange: function handleChange(value) {
      this.formData.forEach(function (item) {
        if (item.type === 'cascader') item.key = value;
      });
    },
    setdefultformdta: function setdefultformdta(data) {
      this.formData = data;
    },
    searchForm: function searchForm() {
      this.$emit('searchForm', this.formData);
    },
    exportTable: function exportTable() {
      this.$emit('exportTable', this.formData);
    },
    addTable: function addTable() {
      this.$emit('addTable', this.formData);
    },
    resetForm: function resetForm() {
      this.$emit('resetForm', this.formData);
    },
    uploadFile: function uploadFile() {
      this.$emit('uploadFile', this.formData);
    }
  }
};